import Model, { attr } from '@ember-data/model';

export default class HelpLink extends Model {
  @attr('string') title;
  @attr('string') embedCode;
  @attr('number') orderNum;
}
